import React from 'react'
import Swal from 'sweetalert2'; 

function AlertSmall(message , icon) {
    let iconNow = icon || 'success';
    let messageNow = message || 'Consulta exitosa';
    //We create a toast alert
    const Toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })
      
    return (
        //We show a loading alert 
        Toast.fire({
            icon: iconNow,
            title: messageNow
          })
    )
}

export default AlertSmall